import FileInput from '../components/FileInput/FileInput';

export const filterFieldsByValue = (jobDataApplicationForm = {}, fieldTypesArray = []) => [
  ...Object.keys(jobDataApplicationForm)?.filter((key) => fieldTypesArray?.includes(jobDataApplicationForm[key])),
];

export const filteredForm = (schema, jobDataApplicationForm) =>
  Object.keys(schema)
    .filter((key) => [...filterFieldsByValue(jobDataApplicationForm, ['required', 'optional'])].includes(key))
    .reduce((obj, key) => {
      obj[key] = schema[key];
      return obj;
    }, {});

export const validatingData = (helperTextObject, data) => {
  Object.keys(data).forEach((key) => {
    if (key === 'phone') {
      if (!/^(09|۰۹|۰٩)[0-9۰-۹٠-٩]{9}$/.test(data[key])) {
        helperTextObject.phone = 'لطفا شماره تلفن معتبر وارد کنید';
      }
    } else if (key === 'email') {
      if (
        // eslint-disable-next-line max-len,no-control-regex,no-empty-character-class
        !/([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|"([]!# - [ ^ -~	]|(\[	 - ~]))+")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[	 -Z^-~]*])/.test(
          data[key],
        )
      ) {
        helperTextObject.email = 'لطفا ایمیل معتبر وارد کنید';
      }
    } else if (key === 'national_code') {
      if (!/^[0-9۰-۹٠-٩]{1,10}$/.test(data[key])) {
        helperTextObject.national_code = 'لطفا کد ملی معتبر وارد کنید';
      }
    }
  });
};

export const getFormSchema = (helpTexts = {}, requiredFileInputs = [], jobDataApplicationForm = {}, selectOptions = {}) => {
  const fullSchema = {
    first_name: {
      type: 'string',
      title: 'نام',
      ui: { ...('first_name' in helpTexts && { help: helpTexts.first_name }) },
    },
    last_name: { type: 'string', title: 'نام خانوادگی', ui: { ...('last_name' in helpTexts && { help: helpTexts.last_name }) } },
    birthdate: {
      type: 'string',
      format: 'date',
      momentFormat: 'YYYY-MM-DD',
      title: 'تاریخ تولد',
      ui: {
        ...('birthdate' in helpTexts && { help: helpTexts.birthdate }),
      },
    },
    national_code: {
      type: 'string',
      format: 'number',
      title: 'کدملی',
      pattern: '^[0-9۰-۹٠-٩]{1,10}$',
      ui: {
        placeholder: 'مثال: ۰۰۱۲۳۴۵۶۷۸',
        ...('national_code' in helpTexts && { help: helpTexts.national_code }),
      },
    },
    email: {
      type: 'string',
      title: 'ایمیل',
      pattern:
        // eslint-disable-next-line max-len
        "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!# - [ ^ -~ \t]|(\\[\t - ~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])",
      ui: {
        placeholder: 'email@example.com',
        ...('email' in helpTexts && { help: helpTexts.email }),
      },
    },
    gender: {
      type: 'string',
      title: 'جنسیت',
      enum: Object.keys(selectOptions?.genders || {}),
      enumNames: Object.values(selectOptions?.genders || {}),
      ui: {
        ...('gender' in helpTexts && { help: helpTexts.gender }),
      },
    },
    phone: {
      type: 'string',
      format: 'number',
      title: 'شماره تماس',
      pattern: '^(09|۰۹|۰٩)[0-9۰-۹٠-٩]{9}$',
      minLength: 11,
      maxLength: 11,
      ui: {
        placeholder: 'مثال: ۰۹۱۲۳۴۵۶۷۸۹',
        ...('phone' in helpTexts && { help: helpTexts.phone }),
      },
    },
    address: { type: 'string', title: 'آدرس', ui: { ...('address' in helpTexts && { help: helpTexts.address }) } },
    avatar: {
      type: 'string',
      format: 'data-url',
      title: 'عکس',
      isRequired: requiredFileInputs.includes('avatar'),
      ui: {
        widget: FileInput,
        options: {
          accept: '.png,.jpg,.jpeg,.gif',
          ...('avatar' in helpTexts && { help: helpTexts.avatar }),
        },
      },
    },
    education: {
      type: 'object',
      title: 'سوابق تحصیلی',
      properties: {
        university: {
          type: 'string',
          title: 'مؤسسه آموزشی',
          ui: {
            ...('education' in helpTexts && { help: helpTexts.education }),
          },
        },
        grade: {
          type: 'string',
          title: 'مقطع تحصیلی',
          enum: Object.keys(selectOptions?.grades || {}),
          enumNames: Object.values(selectOptions?.grades || {}),
          ui: {
            ...('education' in helpTexts && { help: helpTexts.education }),
          },
        },
        branch: {
          type: 'string',
          title: 'رشته تحصیلی',
          ui: {
            ...('education' in helpTexts && { help: helpTexts.education }),
          },
        },
        date_from_year: {
          type: 'string',
          title: 'سال شروع',
          enum: Object.keys(selectOptions?.years || {}),
          enumNames: Object.values(selectOptions?.years || {}),
        },
        date_from_month: {
          type: 'string',
          title: 'ماه شروع',
          enum: Object.keys(selectOptions?.months || {}),
          enumNames: Object.values(selectOptions?.months || {}),
        },
        date_to_year: {
          type: 'string',
          title: 'سال پایان',
          enum: Object.keys(selectOptions?.years || {}),
          enumNames: Object.values(selectOptions?.years || {}),
        },
        date_to_month: {
          type: 'string',
          title: 'ماه پایان',
          enum: Object.keys(selectOptions?.months || {}),
          enumNames: Object.values(selectOptions?.months || {}),
        },
        until_now: {
          type: 'boolean',
          title: 'همچنان مشغول به تحصیل هستم',
        },
      },
      required: requiredFileInputs.includes('education') ? ['university', 'grade', 'branch'] : [],
    },
    job_experience: {
      type: 'object',
      title: 'سوابق شغلی',
      properties: {
        category: {
          type: 'string',
          title: 'گروه شغلی',
          enum: Object.keys(selectOptions?.job_categories || {}),
          enumNames: Object.values(selectOptions?.job_categories || {}),
        },
        job_title: {
          type: 'string',
          title: 'عنوان شغلی',
          ui: {
            ...('job_experience' in helpTexts && { help: helpTexts.job_experience }),
          },
        },
        industry: {
          type: 'string',
          title: 'صنعت',
          enum: Object.keys(selectOptions?.industries || {}),
          enumNames: Object.values(selectOptions?.industries || {}),
        },
        company: {
          type: 'string',
          title: 'نام سازمان',
          ui: {
            ...('job_experience' in helpTexts && { help: helpTexts.job_experience }),
          },
        },
        seniority: {
          type: 'string',
          title: 'سطح ارشدیت',
          enum: Object.keys(selectOptions?.seniorities || {}),
          enumNames: Object.values(selectOptions?.seniorities || {}),
        },
        date_from_year: {
          type: 'string',
          title: 'سال شروع',
          enum: Object.keys(selectOptions?.years || {}),
          enumNames: Object.values(selectOptions?.years || {}),
        },
        date_from_month: {
          type: 'string',
          title: 'ماه شروع',
          enum: Object.keys(selectOptions?.months || {}),
          enumNames: Object.values(selectOptions?.months || {}),
        },
        date_to_year: {
          type: 'string',
          title: 'سال پایان',
          enum: Object.keys(selectOptions?.years || {}),
          enumNames: Object.values(selectOptions?.years || {}),
        },
        date_to_month: {
          type: 'string',
          title: 'ماه پایان',
          enum: Object.keys(selectOptions?.months || {}),
          enumNames: Object.values(selectOptions?.months || {}),
        },
        until_now: {
          type: 'boolean',
          title: 'همچنان مشغول به کار هستم',
          isRequired: requiredFileInputs.includes('job_experience'),
        },
      },
      required: requiredFileInputs.includes('job_experience') ? ['job_title', 'company', 'category', 'industry'] : [],
    },
    certification: {
      type: 'object',
      title: 'گواهی ها',
      properties: {
        institute: {
          type: 'string',
          title: 'مؤسسه آموزشی',
          ui: {
            ...('certification' in helpTexts && { help: helpTexts.certification }),
          },
        },
        major: {
          type: 'string',
          title: 'عنوان',
          ui: {
            ...('certification' in helpTexts && { help: helpTexts.certification }),
          },
        },
        duration: {
          type: 'number',
          title: 'مدت زمان',
          ui: {
            ...('certification' in helpTexts && { help: helpTexts.certification }),
          },
        },
        description: {
          type: 'string',
          title: 'توضیحات',
        },
        file: {
          type: 'string',
          format: 'data-url',
          title: 'فایل گواهی',
          isRequired: requiredFileInputs.includes('certification'),
          ui: {
            widget: FileInput,
            ...('certification' in helpTexts && { help: helpTexts.certification }),
          },
        },
      },
      required: requiredFileInputs.includes('certification') ? ['institute', 'major', 'duration', 'file'] : [],
    },
    cover_letter: {
      type: 'string',
      title: 'توضیحات',
      ui: { ...('cover_letter' in helpTexts && { help: helpTexts.cover_letter }) },
    },
    military_status: {
      type: 'string',
      title: 'وضعیت معافیت',
      enum: Object.keys(selectOptions?.military_statuses || {}),
      enumNames: Object.values(selectOptions?.military_statuses || {}),
      ui: { ...('military_status' in helpTexts && { help: helpTexts.military_status }) },
    },
    attachment: {
      type: 'string',
      title: 'رزومه',
      isRequired: requiredFileInputs.includes('attachment'),
      hasError: requiredFileInputs.includes('attachment') && 'attachment' in helpTexts,
      ui: {
        widget: FileInput,
        ...('attachment' in helpTexts && { help: helpTexts.attachment }),
        options: {
          accept: '.pdf',
        },
      },
    },
  };
  return Object.keys(jobDataApplicationForm).length > 0 ? filteredForm(fullSchema, jobDataApplicationForm) : fullSchema;
};

export function getAutomationBackendServer() {
  if (process.env.BROWSER) {
    return localStorage.getItem('automationBackendUrl') || process.env.AUTOMATION_API_URL;
  }
  return process.env.AUTOMATION_API_URL;
}
